import React, { useEffect, useReducer } from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";

import { Action, State } from "./definitions";
import { reducer, initialState, initialize, actions, thunks } from "./module";

import Field from "./Field";

interface Props {
  price: number;
}

export const CottonCandyCalculator = ({
  state,
  dispatch,
}: {
  state: State;
  dispatch: React.Dispatch<Action>;
}) => {
  const handleConesPerHourChanged = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) =>
    dispatch({ type: actions.rateChanged, payload: value });

  const handlePricePerConeChanged = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) =>
    dispatch({ type: actions.pricePerUnitChanged, payload: value });

  const handleCostPerConeChanged = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) =>
    dispatch({ type: actions.costPerUnitChanged, payload: value });

  const handleCalculateClicked = () => {
    thunks.calculate(state)(dispatch);
  };

  const handleResetClicked = () =>
    dispatch({
      type: actions.dataReinitialized,
      payload: state.price,
    });

  return (
    <div className="calc calc--cottoncandy">
      <div className="calc__heading">
        <h4 className="calc__title">Generated Profit Calculator</h4>
      </div>
      <div className="calc__body">
        <form className="form">
          <div className="form__split">
            <Field
              value={state.rate}
              name="Cones per Hour"
              label="Enter cones"
              error={state.errors.rate}
              onChange={handleConesPerHourChanged}
            />
            <Field
              value={state.pricePerUnit}
              name="Sell Price per Cone"
              label="Enter price"
              error={state.errors.pricePerUnit}
              onChange={handlePricePerConeChanged}
            />
            <Field
              value={state.costPerUnit}
              name="Cost per Cone"
              label="Enter cost"
              error={state.errors.costPerUnit}
              onChange={handleCostPerConeChanged}
            />
          </div>
          <hr />
          <div className="form__split">
            <div className="form__group cols-md-6 cols-sm--6">
              <div className="totalbox">
                <div className="totalbox__heading">
                  &nbsp;Profit per Cone&nbsp;
                </div>
                <div className="totalbox__value">
                  {state.profitPerUnit &&
                    formatAsCurrency.formatIfUndefined(state.profitPerUnit)}
                </div>
              </div>
            </div>
            <div className="form__group cols-md-6 cols-sm--6">
              <div className="totalbox">
                <div className="totalbox__heading">
                  &nbsp;Machine Pays for Itself In&nbsp;
                </div>
                <div className="totalbox__value" id="breakEven">
                  {state.breakEven &&
                    (state.breakEven > 0
                      ? `${state.breakEven.toFixed(1)} Hours`
                      : "Infinity Hours")}
                </div>
              </div>
            </div>
            <div className="form__group cols-md-4 cols-sm--6">
              <div className="totalbox">
                <div className="totalbox__heading">
                  &nbsp;Daily Profit&nbsp;
                </div>
                <div className="totalbox__value">
                  {state.dailyProfit &&
                    formatAsCurrency.formatIfUndefined(state.dailyProfit)}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="calc__footer">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={handleCalculateClicked}
        >
          Calculate
        </button>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <a
          style={{ cursor: "pointer" }}
          type="button"
          className="calc__reset"
          onClick={handleResetClicked}
        >
          Reset
        </a>
      </div>
    </div>
  );
};

export default ({ price }: Props) => {
  const [state, dispatch] = useReducer(
    reducer,
    initialState,
    initialize(price),
  );

  useEffect(() => {
    dispatch({ type: actions.dataReinitialized, payload: price });
  }, [price]);

  return <CottonCandyCalculator state={state} dispatch={dispatch} />;
};
